import React, { useState, useEffect } from "react"
import axios from 'axios';
import branchAuthHeader from "helpers/branchAuthHeader";
import Flatpickr from "react-flatpickr";

import MetaTags from "react-meta-tags"
import {
    Card,
    CardBody,
    Table,
    Col,
    Container,
    Form,
    Label,
    NavItem,
    NavLink,
    Row,
    TabContent,
    TabPane,
    InputGroup,
    Button,
    FormGroup,
    Input
} from "reactstrap"

// Formik validation
import * as Yup from "yup";
import { ErrorMessage, useFormik } from "formik";
import { useHistory } from "react-router-dom";
import classnames from "classnames";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
//Import BranchLogin Details
import { getAPIUrl, getAllBranchLoginCustomerList, getCustomerProfileDetails, getRegistrationDetailsByRefNo } from "../../helpers/fakebackend_helper"
//redux
import { useSelector, useDispatch } from "react-redux";
import PropTypes from 'prop-types';
//Pagination
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
    PaginationListStandalone,
    PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import moment from "moment";
import { get } from "jquery";

const CustomerList = (props) => {


    const formButtonFirstPage = {
        marginLeft: "15px",
        backgroundColor: "#9a084f",
        fontSize: "small",
        borderRadius: "0.50rem"
    }

    const formMandatory = {
        color: "red",
        fontWeight: "bold"
    }
    const tabHeading = {
        color: "#9a084f",
        fontWeight: "bold"
    }

    const formBackground = {
        borderRadius: 8,
        flex: 1,
        //backgroundColor: "rgb(247 242 242)",
        padding: "15px"
    }
    const cardBackground = {
        borderRadius: 15,
        flex: 1,
        marginTop: "20px",
        boxShadow: "#504f4f6b 5px 5px 20px",
        // height: "90%"
    }

    //=============Define State====================
    const history = useHistory();

    const [customerAccList, setCustomerAccList] = useState([]);
    const [showEasing, setshowEasing] = useState("swing");
    const [hideEasing, sethideEasing] = useState("linear");
    const [showMethod, setshowMethod] = useState("fadeIn");
    const [hideMethod, sethideMethod] = useState("fadeOut");
    const [showDuration, setshowDuration] = useState(300);
    const [hideDuration, sethideDuration] = useState(1000);
    const [timeOut, settimeOut] = useState(2000);
    const [extendedTimeOut, setextendedTimeOut] = useState(1000);

    // State to store data of Customer Profile Detailed Report
    const [customerProfileDetailsList, setCustomerProfileDetailsList] = useState([]);

    //pagination customization
    const [modal, setModal] = useState(false)

    const { SearchBar } = Search
    const toggle = () => {
        setModal(!modal)
    }
    const defaultSorted = [
        {
            dataField: "lastUpdated",
            order: "desc",
        },
    ]
    const CustomerPartialColumns = toggleModal => [
        {
            dataField: "lastUpdated",
            text: "Last updated",
            sort: true,
            style: { textAlign: "center", border: "1px solid lightgrey" },
        },
        {
            dataField: "referenceNo",
            text: "Reference No.",
            sort: true,
            style: { textAlign: "center", border: "1px solid lightgrey" },
        },
        {
            dataField: "mobileNo",
            text: "Mobile Number",
            sort: true,
            style: { textAlign: "center", border: "1px solid lightgrey" },
        },
        {
            dataField: "mobileNoMismatch",
            text: "Mobile No. Mismatch",
            sort: true,
            style: { textAlign: "center", border: "1px solid lightgrey" },
        },
        {
            dataField: "customerName",
            text: "Customer Name",
            sort: true,
            style: { textAlign: "center", border: "1px solid lightgrey" },
        },
        {
            dataField: "accountTypeName",
            text: "Account Type",
            sort: true,
            style: { textAlign: "center", border: "1px solid lightgrey" },
        },
        {
            dataField: "entityTypeName",
            text: "Entity Type",
            sort: true,
            style: { textAlign: "center", border: "1px solid lightgrey" },
        },
        {
            dataField: "holdersCount",
            text: "Number of Holder",
            sort: true,
            style: { textAlign: "center", border: "1px solid lightgrey" },
        },
    ]
    var CustomersPartial = customerAccList
      .filter(obj => obj.status === "Partially Filled")
      .map(data => ({
        ...data,
        mobileNoMismatch: data.mobileNoMismatch
          ? "Yes"
          : data.mobileNoMismatch === false
          ? "No"
          : "",
      }))

    const pageOptionsParial = {
        sizePerPage: 10,
        totalSize: CustomersPartial.length,
        custom: true,
    }

    const CustomerCompletedColumns = toggleModal => [
        {
            dataField: "referenceNo",
            text: "View/Download",
            sort: true,
            style: { textAlign: "center", border: "1px solid lightgrey" },
            formatter: (cellContent, row) => {
                return (
                    <div>
                        <button
                            type="button"
                            color="primary"
                            className="btn btn-primary"
                            onClick={() => {
                                ViewRegistrationPDF(row.id)
                            }}
                        ><i className="bx bx-show"></i>
                        </button>&nbsp;&nbsp;
                        <button
                            type="button"
                            color="primary"
                            className="btn btn-primary"
                            onClick={() => {
                                DownloadRegistrationPDF(row.referenceNo, row.id)
                            }}
                        ><i className="bx bx-download"></i>
                        </button>
                    </div>

                )
            }
        },
        {
            dataField: "lastUpdated",
            text: "Last updated",
            sort: true,
            style: { textAlign: "center", border: "1px solid lightgrey" },
        },
        {
            dataField: "referenceNo",
            text: "Reference No.",
            sort: true,
            style: { textAlign: "center", border: "1px solid lightgrey" },
        },
        {
            dataField: "mobileNo",
            text: "Mobile Number",
            sort: true,
            style: { textAlign: "center", border: "1px solid lightgrey" },
        },
        {
            dataField: "mobileNoMismatch",
            text: "Mobile No. Mismatch",
            sort: true,
            style: { textAlign: "center", border: "1px solid lightgrey" },
        },
        {
            dataField: "customerName",
            text: "Customer Name",
            sort: true,
            style: { textAlign: "center", border: "1px solid lightgrey" },
        },
        {
            dataField: "accountTypeName",
            text: "Account Type",
            sort: true,
            style: { textAlign: "center", border: "1px solid lightgrey" },
        },
        {
            dataField: "entityTypeName",
            text: "Entity Type",
            sort: true,
            style: { textAlign: "center", border: "1px solid lightgrey" },
        },
        {
            dataField: "holdersCount",
            text: "Number of Holder",
            sort: true,
            style: { textAlign: "center", border: "1px solid lightgrey" },
        },
    ]

    const getLast15DaysRange = () => {
        const toDate_ = moment().format('DD-MMM-YYYY');
        const fromDate_ = moment().subtract(15, 'days').format('DD-MMM-YYYY');
        return { fromDate_, toDate_ };
    };

    const { fromDate_, toDate_ } = getLast15DaysRange();

    var CustomersCompleted = customerAccList
        .filter(obj => obj.status === "Completed")
        .map(data => ({
        ...data,
        mobileNoMismatch: data.mobileNoMismatch
            ? "Yes"
            : data.mobileNoMismatch === false
            ? "No"
            : "",
        }))

    const pageOptionsCompleted = {
        sizePerPage: 10,
        totalSize: CustomersCompleted.length,
        custom: true,
    }
    function SuccessMessage(message) {
        toastr.options = {
            positionClass: "toast-top-center",
            timeOut: timeOut,
            extendedTimeOut: extendedTimeOut,
            closeButton: true,
            debug: false,
            progressBar: false,
            preventDuplicates: false,
            newestOnTop: false,
            showEasing: showEasing,
            hideEasing: hideEasing,
            showMethod: showMethod,
            hideMethod: hideMethod,
            showDuration: showDuration,
            hideDuration: hideDuration
        };

        toastr.success(message, "Information");
    }

    function ErrorMessage(message) {
        toastr.options = {
            positionClass: "toast-top-center",
            timeOut: timeOut,
            extendedTimeOut: extendedTimeOut,
            closeButton: true,
            debug: false,
            progressBar: false,
            preventDuplicates: false,
            newestOnTop: false,
            showEasing: showEasing,
            hideEasing: hideEasing,
            showMethod: showMethod,
            hideMethod: hideMethod,
            showDuration: showDuration,
            hideDuration: hideDuration
        };

        toastr.error(message, "Error");
    }

    // View POI Files of Detailed Customer Profile Report
    function ViewPOIFiles(path) {
        debugger;
        var url = getAPIUrl() + "/POIFiles/" + path;
        window.open(url, "_blank");
    }

    // Group of allowed branches to see the detailed report
    const allowedBranchesToSeeDetailedReport = [735, 737];

    // Data Table and Pagination for Customer Profile Detailed Report
    // --- Data Table Columns ---
    const CustomerProfileDetailsColumns = toggle => [
        {
            dataField: "viewPoi",
            text: "View POI",
            sort: true,
            style: { textAlign: "center", border: "1px solid lightgrey" },
            formatter: (cellContent, row) => {
                const poi_file_path = row?.poiFilePath;
                return (
                    <div>
                        <button
                            type="button"
                            color="primary"
                            className="btn btn-primary"
                            onClick={() => {
                                ViewPOIFiles(poi_file_path)
                            }}
                        ><i className="bx bx-show"></i>
                        </button>&nbsp;&nbsp;
                    </div>
                );
            }
        },
        { dataField: "referenceNo", text: "Reference No.", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "locationName", text: "Location Name", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "branchName", text: "Branch Name", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "customerId", text: "Customer Id", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "ckycNo", text: "CKYC No", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "customerTitle", text: "Customer Title", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "customerName", text: "Customer Name", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "localAddress1", text: "Local Address 1", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "localAddress2", text: "Local Address 2", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "localAddress3", text: "Local Address 3", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "localCity", text: "Local City", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "localPin", text: "Local Pin", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "localState", text: "Local State", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "permanentAddress1", text: "Permanent Address 1", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "permanentAddress2", text: "Permanent Address 2", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "permanentAddress3", text: "Permanent Address 3", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "permanentCity", text: "Permanent City", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "permanentPin", text: "Permanent Pin", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "permenantState", text: "Permanent State", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "mobile", text: "Mobile", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "email", text: "Email", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "pan", text: "PAN", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "poi", text: "POI", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "poiNo", text: "POI No", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        // { dataField: "poiFilePath", text: "POI File Path", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "dob", text: "DOB", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "gender", text: "Gender", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "nationality", text: "Nationality", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "maritalStatus", text: "Marital Status", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "mobileNoBelongsTo", text: "Mobile No Belongs To", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "occupation", text: "Occupation", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "fatherTitle", text: "Father Title", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "fatherName", text: "Father Name", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "motherTitle", text: "Mother Title", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "motherName", text: "Mother Name", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "maidenTitle", text: "Maiden Title", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "maidenName", text: "Maiden Name", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "relatedPersonName", text: "Related Person Name", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "relatedPersonCustomerRelation", text: "Related Person Customer Relation", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "relatedPersonType", text: "Related Person Type", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "relatedPersonPANNo", text: "Related Person PAN No", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "relatedPersonAadhaarNo", text: "Related Person Aadhaar No", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "relatedPersonCourtOrderNo", text: "Related Person Court Order No", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "declarantTransactionParticulars", text: "Declarant Transaction Particulars", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "declarantAmountofTransaction", text: "Declarant Amount Of Transaction", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "declarantAssessedTax", text: "Declarant Assessed Tax", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "detailsOfIncomeTax", text: "Details Of Income Tax", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "reasonForNoPan", text: "Reason For No PAN", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "debitCard", text: "Debit Card", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "smsBanking", text: "SMS Banking", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "mobileBanking", text: "Mobile Banking", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "statementOnEmail", text: "Statement On Email", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "aadhaarCardSeeding", text: "Aadhaar Card Seeding", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "interntBanking", text: "Internet Banking", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "fundsExpectedOrigin", text: "Funds Expected Origin", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "fundsUtilisationExpected", text: "Funds Utilisation Expected", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "otherBankAccounts", text: "Other Bank Accounts", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "turnover", text: "Turnover", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "averageIncome", text: "Average Income", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "averageBalance", text: "Average Balance", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "education", text: "Education", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "religion", text: "Religion", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "occupationDetails", text: "Occupation Details", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "lineOfBusiness", text: "Line Of Business", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "businessName", text: "Business Name", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "businessStartDate", text: "Business Start Date", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "businessAddress", text: "Business Address", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "businessTelNo", text: "Business Tel No", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "businessMobileNo", text: "Business Mobile No", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "businessAnnualIncome", text: "Business Annual Income", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "businessIncomeSource", text: "Business Income Source", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "businessWealthSource", text: "Business Wealth Source", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "businessEstimatedValue", text: "Business Estimated Value", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "businessAssetDetails", text: "Business Asset Details", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "businessCarMaker", text: "Business Car Maker", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "caste", text: "Caste", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "customerReason", text: "Customer Reason", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "vehicleType", text: "Vehicle Type", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "purchaseYear", text: "Purchase Year", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "bornNonIndia", text: "Born Non India", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "taxResidenceNonIndia", text: "Tax Residence Non India", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "interestedIn", text: "Interested In", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "nomineeName", text: "Nominee Name", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "nomineeAddress", text: "Nominee Address", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "relationship", text: "Relationship", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "minorDOB", text: "Minor DOB", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "guardianName", text: "Guardian Name", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "guardianAddress", text: "Guardian Address", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } },
        { dataField: "guardianRelation", text: "Guardian Relation", sort: true, style: { textAlign: "center", border: "1px solid lightgrey" } }
    ];

    const pageOptionsForDetailedReport = {
        sizePerPage: 10,
        totalSize: customerProfileDetailsList.length,
        custom: true,
    }


    const dispatch = useDispatch();
    const formButton = {
        marginLeft: "20px",
        backgroundColor: "#9a084f",
        fontSize: "small",
        borderRadius: "0.50rem"
    }

    function tog_backdrop() {
        setmodal_backdrop(!modal_backdrop);
        removeBodyCss();
    }

    function DownloadRegistrationPDF(fileName, id) {
        debugger;
        //Development url
        var url = getAPIUrl() + "/RegistrationPrintPDF/" + id + ".pdf";

        axios({
            url: url, //your url
            method: 'GET',
            responseType: 'blob', // important
            headers: branchAuthHeader()
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName + ".pdf"); //or any other extension
            document.body.appendChild(link);
            link.click();
        });

        //var a = $("<a target='_blank' rel='noreferrer'/>");
        //a.attr("download", fileName);
        //a.attr("href", url);
        //$("body").append(a);
        //a[0].click();
        //$("body").remove(a);
    };

    function ViewRegistrationPDF(id) {
        debugger;
        var url = getAPIUrl() + "/RegistrationPrintPDF/" + id + ".pdf";

        axios({
            url: url, //your url
            method: 'GET',
            responseType: 'blob', // important
            headers: branchAuthHeader()
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));

            const file = new Blob([response.data], {
                type: "application/pdf",
            });

            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
        });

        //var a2 = $("<a target='_blank' rel='noreferrer'/>");
        //a2.attr("target", "_blank");
        //a2.attr("href", url);
        //$("body").append(a2);
        //a2[0].click();
        //$("body").remove(a2);
    };

    function ViewRegistrationPDF(fileName) {
        debugger;
        var url = getAPIUrl() + "/RegistrationPrintPDF/" + fileName + ".pdf";

        var a = $("<a target='_blank' rel='noreferrer'/>");
        a.attr("target", "_blank");
        a.attr("href", url);
        $("body").append(a);
        a[0].click();
        $("body").remove(a);
    };

    var authUserName = JSON.parse(localStorage.getItem('userName'));
    var userDescription = JSON.parse(localStorage.getItem('usedesc'));
    var authPassword = JSON.parse(localStorage.getItem('password'));

    const [username, setusername] = useState(authUserName);
    const [isPreloader, setPreloader] = useState(false);
    const [date, setDate] = useState({
        fromDate: fromDate_,
        toDate: toDate_
    })
    const [referenceNumber, setReferenceNumber] = useState(null)
    const [searchBy, setSearchBy] = useState("DATE");


    function GetBranchloginDetails(BranchCode) {
        debugger;

        const getAllBranchLoginCustomerListModel = {
            BranchCode: BranchCode,
            fromDate: date.fromDate,
            toDate: date.toDate
        }
        if (getAllBranchLoginCustomerListModel != null) {
            setPreloader(true);

            axios.post(getAllBranchLoginCustomerList(), getAllBranchLoginCustomerListModel, { headers: branchAuthHeader() }).then((response) => {
                setCustomerAccList(response.data);
                setPreloader(false);
                if (response.data?.length === 0) {
                    ErrorMessage("No records available")
                }
            }, (error) => {
                console.log(error.response);
                setPreloader(false);
            });
        }
    }

    function GetBranchloginDetailsViaReferenceNo() {
        debugger;

        const payload = {
            ReferenceNo: referenceNumber,
        }

        if (payload?.ReferenceNo !== null) {
            setPreloader(true);

            axios.post(getRegistrationDetailsByRefNo(), payload, { headers: branchAuthHeader() }).then((response) => {
                setCustomerAccList(response.data);
                setPreloader(false);
                if (response.data?.length === 0) {
                    ErrorMessage("No records available")
                }
            }, (error) => {
                console.log(error.response);
                setPreloader(false);
            });
        } else {
            ErrorMessage("Please enter the Reference Number")
        }
    }

    // Function to fetch data of Customer Profile Detailed Report
    function GetDetailedCustomerProfileReport() {
        debugger;

        const payload = {
            fromDate: date.fromDate,
            toDate: date.toDate
        }

        setPreloader(true);
        axios.post(getCustomerProfileDetails(), payload, { headers: branchAuthHeader() }).then((response) => {
            setCustomerProfileDetailsList(response.data);
            setPreloader(false);
            if (response.data?.length === 0) {
                ErrorMessage("No records available")
            }
        }, (error) => {
            console.log(error.response);
            setPreloader(false);
        });
    }

    useEffect(() => {
        if (isPreloader === true) {
            document.getElementById("preloader").style.display = "block";
            document.getElementById("status").style.display = "block";
        } else {
            document.getElementById("preloader").style.display = "none";
            document.getElementById("status").style.display = "none";
        }
    }, [isPreloader]);

    useEffect(() => {
        var isAdmin = JSON.parse(localStorage.getItem('isAdmin'))
        var branchcode = localStorage.getItem('branchCode');
        if (isAdmin) {
            GetBranchloginDetails("");
        } else {
            GetBranchloginDetails(branchcode);
        }
    }, []);


    const [activeTabVartical, setoggleTabVertical] = useState(1)
    const [passedStepsVertical, setPassedStepsVertical] = useState([1])

    function toggleTabVertical(tab) {
        if (activeTabVartical !== tab) {
            var modifiedSteps = [...passedStepsVertical, tab]

            if (tab >= 1 && tab <= 2) {
                setoggleTabVertical(tab)
                setPassedStepsVertical(modifiedSteps)
            }
        }
    }

    const [menu, setMenu] = useState(false)


    // Function to change the date
    const handleChangeDate = (date, fieldName) => {
        setDate((prev) => ({
            ...prev,
            [fieldName]: date
        }))
    }

    // Function to handle search
    const handleSearch = () => {
        var branchcode = localStorage.getItem('branchCode');
        var isAdmin = JSON.parse(localStorage.getItem("isAdmin"));

        if (searchBy === "REF-NO") {
            GetBranchloginDetailsViaReferenceNo()
        } else if (searchBy === "DETAILED_REPORT") {
            GetDetailedCustomerProfileReport()
        } else if (isAdmin) {
            GetBranchloginDetails("");
        } else {
            GetBranchloginDetails(branchcode);
        }
    }

    // Function to handle change in checkbox
    const handleCheckBox = (event, action) => {
        const { checked } = event?.target;
        var isAdmin = JSON.parse(localStorage.getItem("isAdmin"));
        var branchcode = localStorage.getItem('branchCode');
        if (checked && action === "REF-NO") {
            setSearchBy("REF-NO")
        } else if (checked && action === "DETAILED_REPORT") {
            setSearchBy("DETAILED_REPORT")
            $('#refNoCheckbox').prop('checked', false);
        } else if (!checked) {
            setSearchBy("DATE")
            setReferenceNumber(null)
            if (isAdmin) {
                GetBranchloginDetails("");
            } else {
                GetBranchloginDetails(branchcode);
            }
        }
    }

    const handleChangeRefNo = (event) => {
        const inputValue = event.target.value;

        // Keep only digits using regex (remove all non-digits)
        const numericValue = inputValue.replace(/\D/g, "");

        // Set state only if there's a valid number or empty
        setReferenceNumber(numericValue === "" ? null : numericValue);
    };

    const exportToCSV = (data, filename = `${new Date().getTime()}.csv`) => {
        if (!data || !data.length) {
          ErrorMessage('No data to export');
          return;
        }

        // Define the order and keys to export
        const headers = [
            { label: 'Last updated', key: 'lastUpdated' },
            { label: 'Reference No.', key: 'referenceNo', isReference: true },
            { label: 'Mobile Number', key: 'mobileNo' },
            { label: 'Mobile No. Mismatch', key: 'mobileNoMismatch' },
            { label: 'Customer Name', key: 'customerName' },
            { label: 'Account Type', key: 'accountTypeName' },
            { label: 'Entity Type', key: 'entityTypeName' },
            { label: 'Number of Holder', key: 'holdersCount' }
        ];
      
        const csvHeaders = headers.map(h => h.label).join(',') + '\n';

        const csvRows = data.map(row =>
            headers.map(h => {
              let value = row[h.key] ?? '';
              if (h.isReference) {
                return `"=""${value}"""`; // Ensures Excel sees it as a string with leading 0s
              }
              return `"${String(value).replace(/"/g, '""')}"`;
            }).join(',')
          ).join('\n');

        // console.log("CSV Rows:", csvRows);  
        
        const csvContent = csvHeaders + csvRows;
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };


    const exportCustomerDetailsToCSV = (data, filename = `${new Date().getTime()}.csv`) => {
        if (!data || !data.length) {
          ErrorMessage('No data to export');
          return;
        }

        // Define the order and keys to export
        const headers = CustomerProfileDetailsColumns()
        .filter(col => col.dataField !== "viewPoi")
        .map(col => {
            return { 
                label: col.text, 
                key: col.dataField, 
                isReference: col.dataField === "referenceNo" 
            };
        });
      
        const csvHeaders = headers.map(h => h.label).join(',') + '\n';

        const csvRows = data.map(row =>
            headers.map(h => {
              let value = row[h.key] ?? '';
              if (h.isReference) {
                return `"=""${value}"""`; // Ensures Excel sees it as a string with leading 0s
              }
              return `"${String(value).replace(/"/g, '""')}"`;
            }).join(',')
          ).join('\n');

        // console.log("CSV Rows:", csvRows);  
        
        const csvContent = csvHeaders + csvRows;
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      

    return (
        <React.Fragment>
            <div id="preloader">
                <div id="status">
                    <div className="spinner-chase">
                        <div className="chase-dot" />
                        <div className="chase-dot" />
                        <div className="chase-dot" />
                        <div className="chase-dot" />
                        <div className="chase-dot" />
                        <div className="chase-dot" />
                    </div>
                </div>
            </div>

            <MetaTags>
                <title>JSB-Customer Details</title>
            </MetaTags>
            <Container fluid={true}>
                <Row>
                    <Col lg="12">
                        <Card style={cardBackground}>
                            <CardBody>
                                <Row>
                                    <Col lg="12">
                                        <h4 className="card-title" style={{ fontSize: "17px", color: "#941116", fontWeight: "bold" }}>{localStorage.getItem('branchName')}</h4>
                                    </Col>
                                    <Col lg="12">
                                        <div className="d-flex gap-3">
                                            <div>
                                                <Input
                                                    type="checkbox"
                                                    id="refNoCheckbox"
                                                    className="form-check-input"
                                                    disabled={searchBy === "DETAILED_REPORT" ? true : false}
                                                    onChange={(e) => handleCheckBox(e, "REF-NO")}
                                                />
                                                <label style={{color: 'black'}}>&nbsp;Search By Reference Number</label>
                                            </div>

                                        {allowedBranchesToSeeDetailedReport.includes(Number(userDescription)) && (
                                            <div>
                                                <Input
                                                    type="checkbox"
                                                    id="detailedReportCheckbox"
                                                    className="form-check-input"
                                                    onChange={(e) => handleCheckBox(e, "DETAILED_REPORT")}
                                                />
                                                <label style={{color: 'black'}}>&nbsp;Get Customer Profile Details</label>
                                            </div>
                                        )}
                                        </div>
                                    </Col>                                    
                                    {(searchBy === "DATE" || searchBy === "DETAILED_REPORT") ? (
                                        <>
                                            <Col lg="2">
                                                <label style={{color: "black"}}>From Date</label>
                                                <InputGroup>
                                                    <Flatpickr
                                                        className="form-control d-block flatpickr"
                                                        placeholder="From Date"
                                                        value={date.fromDate}
                                                        onChange={(e, dateStr, self, data) => {
                                                            handleChangeDate(dateStr, "fromDate")
                                                        }}
                                                        options={{
                                                            dateFormat: "d-M-Y",
                                                            altFormat: "F j, Y",
                                                            maxDate: "today",
                                                            disableMobile: "true"
                                                        }}
                                                    />
                                                </InputGroup>
                                            </Col>
                                            <Col lg="2">
                                                <label style={{color: "black"}}>To Date</label>
                                                <InputGroup>
                                                    <Flatpickr
                                                        className="form-control d-block flatpickr"
                                                        placeholder="To Date"
                                                        value={date.toDate}
                                                        onChange={(e, dateStr, self, data) => {
                                                            handleChangeDate(dateStr, "toDate")
                                                        }}
                                                        options={{
                                                            dateFormat: "d-M-Y",
                                                            altFormat: "F j, Y",
                                                            maxDate: "today",
                                                            disableMobile: "true"
                                                        }}
                                                    />
                                                </InputGroup>
                                            </Col>
                                        </>
                                    ) : (
                                        <Col lg="2">
                                            <div className="position-relative">
                                                <Input
                                                    type="text"
                                                    id="ReferenceNo"
                                                    className="form-control"
                                                    maxLength="15"
                                                    placeholder="Enter Reference Number"
                                                    value={referenceNumber ?? ""}
                                                    onChange={handleChangeRefNo}
                                                />
                                                
                                                {referenceNumber && (
                                                    <button
                                                        type="button"
                                                        className="btn position-absolute top-50 end-0 translate-middle-y me-2 p-0 border-0 bg-transparent fs-3"
                                                        onClick={() => setReferenceNumber(null)}
                                                        aria-label="Clear"
                                                        style={{color: "#9a084f"}}
                                                    >
                                                        &times;
                                                    </button>
                                                )}
                                            </div>
                                        </Col>
                                    )}
                                    <Col lg="2" className="d-flex align-items-end">
                                        <Button style={formButton} 
                                            onClick={handleSearch}
                                        >
                                            Search
                                        </Button>
                                    </Col>
                                </Row>
                                <br />
                                {searchBy === "DATE" || searchBy === "REF-NO" ? (
                                    <div className="wizard clearfix">
                                        <div className="steps clearfix">
                                            <ul>
                                                <NavItem
                                                    className={classnames({
                                                        current: activeTabVartical === 1,
                                                    })}
                                                >
                                                    <NavLink
                                                        className={classnames({
                                                            active: activeTabVartical === 1,
                                                        })}
                                                        onClick={() => {
                                                            toggleTabVertical(1)
                                                        }}
                                                    >
                                                        <span className="number">1</span> Completed forms
                                                    </NavLink>
                                                </NavItem>
                                                <NavItem
                                                    className={classnames({
                                                        current: activeTabVartical === 2,
                                                    })}
                                                >
                                                    <NavLink
                                                        className={classnames({
                                                            active: activeTabVartical === 2,
                                                        })}
                                                        onClick={() => {
                                                            toggleTabVertical(2)
                                                        }}
                                                    >
                                                        <span className="number">2</span>{" "}
                                                        <span>Partially Filled Forms</span>
                                                    </NavLink>
                                                </NavItem>
                                            </ul>
                                        </div>

                                        <div className="content clearfix" style={{ marginTop: "-17px", width: "101%" }}>
                                            <br /><br />
                                            <TabContent
                                                activeTab={activeTabVartical}
                                                className="body" >
                                                <TabPane tabId={1}>
                                                    <div>
                                                        <PaginationProvider
                                                            pagination={paginationFactory(pageOptionsCompleted)}
                                                            keyField="id"
                                                            columns={CustomerCompletedColumns(toggle)}
                                                            data={CustomersCompleted}
                                                        >
                                                            {({ paginationProps, paginationTableProps }) => (
                                                                <ToolkitProvider
                                                                    keyField="id"
                                                                    data={CustomersCompleted}
                                                                    columns={CustomerCompletedColumns(toggle)}
                                                                    bootstrap4
                                                                    search
                                                                >
                                                                    {toolkitProps => (
                                                                        <Form style={formBackground} className="registration needs-validation" encType="multipart/form-data" onSubmit={(e) => {
                                                                            e.preventDefault();
                                                                            return false;
                                                                        }}>
                                                                            <React.Fragment>
                                                                                <Row className="mb-2">
                                                                                    <Col md="8">
                                                                                        <Label><h5 style={tabHeading}>Customer Details</h5></Label>
                                                                                    </Col>
                                                                                    <Col md="2">
                                                                                        <div className="search-box me-2 mb-2 d-inline-block">
                                                                                            <div className="position-relative">
                                                                                                <SearchBar
                                                                                                    autoComplete="off"
                                                                                                    style={{ width: "100%", float: "right" }}
                                                                                                    {...toolkitProps.searchProps}
                                                                                                    //onClear={() => setPaginationReset(false)}
                                                                                                />
                                                                                                <i className="bx bx-search-alt search-icon" />
                                                                                            </div>
                                                                                        </div>
                                                                                    </Col>
                                                                                    <Col lg="2">
                                                                                        <Button style={formButton} 
                                                                                            onClick={() => exportToCSV(CustomersCompleted, "Completed_Forms.csv")}
                                                                                        >
                                                                                            Export CSV
                                                                                        </Button>
                                                                                    </Col>
                                                                                </Row>
                                                                            <Row>
                                                                                <Col xl="12">
                                                                                    <div className="table-responsive">
                                                                                        <BootstrapTable keyField="id"
                                                                                            responsive
                                                                                            classes="table align-middle table-nowrap table-check text-center table-striped table-hover"
                                                                                            style={{ textAlign: "center" }}
                                                                                            defaultSorted={defaultSorted}
                                                                                            {...toolkitProps.baseProps}
                                                                                            {...paginationTableProps}>
                                                                                        </BootstrapTable>
                                                                                    </div>
                                                                                </Col>
                                                                            </Row>
                                                                            </React.Fragment>
                                                                            <div className="pagination pagination-rounded justify-content-end">
                                                                                <PaginationListStandalone {...paginationProps} />
                                                                            </div>
                                                                        </Form>
                                                                    )}
                                                                </ToolkitProvider>
                                                            )}
                                                        </PaginationProvider>
                                                    </div>
                                                </TabPane>

                                                <TabPane tabId={2}>
                                                    <div>
                                                        <PaginationProvider
                                                            pagination={paginationFactory(pageOptionsParial)}
                                                            keyField="id"
                                                            columns={CustomerPartialColumns(toggle)}
                                                            data={CustomersPartial}
                                                        >
                                                            {({ paginationProps, paginationTableProps }) => (
                                                                <ToolkitProvider
                                                                    keyField="id"
                                                                    data={CustomersPartial}
                                                                    columns={CustomerPartialColumns(toggle)}
                                                                    bootstrap4
                                                                    search
                                                                >
                                                                    {toolkitProps => (
                                                                        <Form style={formBackground} className="needs-validation" onSubmit={(e) => {
                                                                            e.preventDefault();
                                                                            validation.handleSubmit();
                                                                            return false;
                                                                        }}>
                                                                            <React.Fragment>
                                                                                <Row className="mb-2">
                                                                                    <Col md="8">
                                                                                        <Label><h5 style={tabHeading}>Customer Details</h5></Label>
                                                                                    </Col>
                                                                                    <Col md="2">
                                                                                        <div className="search-box me-2 mb-2 d-inline-block">
                                                                                            <div className="position-relative">
                                                                                                <SearchBar
                                                                                                    autoComplete="off"
                                                                                                    style={{ width: "100%", float: "right" }}
                                                                                                    {...toolkitProps.searchProps}
                                                                                                //onClear={() => setPaginationReset(false)}
                                                                                                />
                                                                                                <i className="bx bx-search-alt search-icon" />
                                                                                            </div>
                                                                                        </div>
                                                                                    </Col>
                                                                                    <Col lg="2">
                                                                                        <Button style={formButton} 
                                                                                            onClick={() => exportToCSV(CustomersPartial, "Partially_Filled_Forms.csv")}
                                                                                        >
                                                                                            Export CSV
                                                                                        </Button>
                                                                                    </Col>
                                                                                </Row>
                                                                            <Row>
                                                                                <Col xl="12">
                                                                                    <div className="table-responsive">
                                                                                        <BootstrapTable keyField="id"
                                                                                            responsive
                                                                                                search="true"
                                                                                            classes="table align-middle table-nowrap table-check text-center table-striped table-hover"
                                                                                            style={{ textAlign: "center" }}
                                                                                            defaultSorted={defaultSorted}
                                                                                            {...toolkitProps.baseProps}
                                                                                            {...paginationTableProps}>
                                                                                        </BootstrapTable>
                                                                                    </div>
                                                                                </Col>
                                                                            </Row>
                                                                            </React.Fragment>
                                                                            
                                                                            <div className="pagination pagination-rounded justify-content-end">
                                                                                <PaginationListStandalone {...paginationProps} />
                                                                            </div>
                                                                        </Form>
                                                                    )}
                                                                </ToolkitProvider>
                                                            )}
                                                        </PaginationProvider>
                                                    </div>
                                                </TabPane>

                                            </TabContent>
                                        </div>
                                    </div >
                                ) : (
                                    <div>
                                        <PaginationProvider
                                            pagination={paginationFactory(pageOptionsForDetailedReport)}
                                            keyField="id"
                                            columns={CustomerProfileDetailsColumns(toggle)}
                                            data={customerProfileDetailsList}
                                        >
                                            {({ paginationProps, paginationTableProps }) => (
                                                <ToolkitProvider
                                                    keyField="id"
                                                    data={customerProfileDetailsList}
                                                    columns={CustomerProfileDetailsColumns(toggle)}
                                                    bootstrap4
                                                    search
                                                >
                                                    {toolkitProps => (
                                                        <Form style={formBackground} className="registration needs-validation" encType="multipart/form-data" onSubmit={(e) => {
                                                            e.preventDefault();
                                                            return false;
                                                        }}>
                                                            <React.Fragment>
                                                                <Row className="mb-2">
                                                                    <Col md="8">
                                                                        <Label><h5 style={tabHeading}>Get Customer Profile Details</h5></Label>
                                                                    </Col>
                                                                    <Col md="2">
                                                                        <div className="search-box me-2 mb-2 d-inline-block">
                                                                            <div className="position-relative">
                                                                                <SearchBar
                                                                                    autoComplete="off"
                                                                                    style={{ width: "100%", float: "right" }}
                                                                                    {...toolkitProps.searchProps}
                                                                                    //onClear={() => setPaginationReset(false)}
                                                                                />
                                                                                <i className="bx bx-search-alt search-icon" />
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                    <Col lg="2">
                                                                        <Button style={formButton} 
                                                                            onClick={() => exportCustomerDetailsToCSV(customerProfileDetailsList, "Customer_Profile_Details.csv")}
                                                                        >
                                                                            Export CSV
                                                                        </Button>
                                                                    </Col>
                                                                </Row>
                                                            <Row>
                                                                <Col xl="12">
                                                                    <div className="table-responsive">
                                                                        <BootstrapTable keyField="id"
                                                                            responsive
                                                                            classes="table align-middle table-nowrap table-check text-center table-striped table-hover"
                                                                            style={{ textAlign: "center" }}
                                                                            // defaultSorted={defaultSorted}
                                                                            {...toolkitProps.baseProps}
                                                                            {...paginationTableProps}>
                                                                        </BootstrapTable>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                            </React.Fragment>
                                                            <div className="pagination pagination-rounded justify-content-end">
                                                                <PaginationListStandalone {...paginationProps} />
                                                            </div>
                                                        </Form>
                                                    )}
                                                </ToolkitProvider>
                                            )}
                                        </PaginationProvider>
                                    </div>
                                )}
                            </CardBody >
                        </Card >
                    </Col >
                </Row >
            </Container >
        </React.Fragment >
    )
}

export default CustomerList

CustomerList.propTypes = {
    history: PropTypes.object,
};